import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { useUpdateEmail } from '@/modules/payment/apiHooks';
import { VerifyEmail } from '@/modules/payment/subscription/components/VerifyEmail';
import { Button, InputField, Typography } from '@/shared/components/atoms';
import { useAuth } from '@/shared/hooks/context/auth';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';
interface IFormValues {
  email: string;
}
const EmailUpdate: React.FC = () => {
  const { user } = useAuth();
  const { openModal, closeModal } = useModal();
  const { t } = useTranslation('payment');
  const { mutate, isLoading } = useUpdateEmail();

  const schema: yup.SchemaOf<IFormValues> = yup.object({
    email: yup
      .string()
      .email('invalid-email')
      .required(t('this-field-is-required'))
      .nullable(false),
  });

  const methods = useForm<IFormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      email: user?.email,
    },
  });

  const {
    getValues,
    handleSubmit,
    register,
    formState: { errors },
  } = methods;

  const onSubmit = () => {
    mutate(getValues('email'), {
      onSuccess: () => {
        closeModal();
        openModal(<VerifyEmail />);
      },
    });
  };

  return (
    <FormProvider {...methods}>
      <form className='flex w-full min-w-[420px] flex-col gap-24'>
        <div className='flex flex-col'>
          <Typography
            variant='h2'
            weight='semiBold'
            className='text-text-default'
          >
            {t('update-email')}
          </Typography>
          <Typography variant='body2' className='text-surface-10'>
            {t('subscribe-email-required')}
          </Typography>
        </div>
        <InputField
          borderColor='border-outline-variant'
          width='w-full'
          py='!py-14'
          label={t('Email Address')}
          placeholder={t('Email Address')}
          error={!!errors.email}
          errorMessage={errors.email?.message}
          className='!rounded-xl bg-background-transparent'
          {...register('email')}
        />
        <Button
          size='full'
          type='submit'
          onClick={handleSubmit(onSubmit)}
          className='mt-32 w-full !rounded-xl py-14 text-base font-semi-bold'
          disabled={isLoading || Boolean(errors.email)}
        >
          {t('continue')}
        </Button>
      </form>
    </FormProvider>
  );
};

export { EmailUpdate };
